// src/App.js
import React from 'react';
import {
  BrowserRouter, Routes, Route, Navigate, Outlet, useLocation, useNavigate
} from 'react-router-dom';

import RegisterEmail from './RegisterEmail';
import RegisterForm from './RegisterForm';
import LoginForm from './LoginForm';
import Logout from './Logout';
import UserInfo from './pages/userInfoPage';
import UserEdit from './pages/userEditPage';

import RegisterPage from './pages/registerPage';
import ContactPage from './pages/contactPage';
import ContactHistoryPage from './pages/contactHistoryPage';
import LoginPage from './pages/loginPage';
import LogoutPage from './pages/logoutPage';
import MyPage from './pages/myPage';
import PasswordReminderPage from './pages/passwordReminderPage';
import IframeContainer from './components/iframeContainer';
import MailChangePage from './pages/mailChangePage';
import WithdrawPage from './pages/withdrawPage';
import WithdrawCompletePage from './pages/withdrawCompletePage';
import IframeAutosizer from './components/IframeAutosizer';

// ----- ログイン必須ガード -----
function RequireAuth() {
  const location = useLocation();
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}

// ----- Router配下でのみ走るブート処理（navigate ブリッジ） -----
function RouterBoot({ base }) {
  const navigate = useNavigate();
  React.useEffect(() => {
    window.__navigate = (to) => navigate(to);
    window.__basename = base;
  }, [navigate, base]);
  return null;
}

// ----- ルート変更時に高さを再通知して確実に追随 -----
function HeightPingOnRoute() {
  const loc = useLocation();
  React.useEffect(() => {
    const parentOrigin = window.location.origin; // 親と同一オリジン想定
    const post = () => {
      const h = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight,
        800
      );
      window.parent.postMessage({ type: 'IFRAME_HEIGHT', height: h }, parentOrigin);
    };
    // すぐ＆描画安定後に数回送ると安定
    post();
    const t1 = setTimeout(post, 50);
    const t2 = setTimeout(post, 250);
    const t3 = setTimeout(post, 600);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [loc]);
  return null;
}

export default function App() {
  const base = process.env.PUBLIC_URL || '/user';

  return (
    <BrowserRouter basename={base}>
      {/* ★ 常駐で自動リサイズ（ResizeObserver + 親からのリクエスト対応） */}
      <IframeAutosizer minHeight={800} />
      {/* ★ ルート変更時の追い打ち通知 */}
      <HeightPingOnRoute />

      <RouterBoot base={base} />

      <Routes>
        {/* === 認証が必要なページ群 === */}
        <Route element={<RequireAuth />}>
          {/* 情報系 */}
          <Route path="info" element={<UserInfo />} />
          <Route path="edit" element={<UserEdit />} />
          <Route path="email/change" element={<MailChangePage />} />
          <Route path="contact_history" element={<ContactHistoryPage />} />

          {/* マイページ配下（必要なら IframeContainer で包む） */}
          <Route path="mypage" element={<IframeContainer><MyPage /></IframeContainer>} />
          <Route path="withdraw" element={<WithdrawPage />} />
          <Route path="withdraw_complete" element={<WithdrawCompletePage />} />
        </Route>

        {/* === 公開ページ === */}
        <Route path="email-auth" element={<RegisterEmail />} />
        <Route path="old/register" element={<RegisterForm />} />
        <Route path="old/login" element={<LoginForm />} />
        <Route path="old/logout" element={<Logout />} />

        <Route path="register" element={<IframeContainer><RegisterPage /></IframeContainer>} />
        <Route path="login" element={<IframeContainer><LoginPage /></IframeContainer>} />
        <Route path="logout" element={<LogoutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="password_reminder" element={<PasswordReminderPage />} />

        {/* 未定義はルートへ（RequireAuth 経由で未ログインは /login へ） */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
